module.exports = __webpack_public_path__ + "static/media/football.486568df.svg";